<template>
  <div class="transfer">
    <SmButton
      class="transfer__btn"
      :loading="isLoad"
      icon="more"
      secondary
      :onClick="retransfer"
    >
      Повторить запись
    </SmButton>
    <Teleport to="body">
      <CustomModal title="Специалист недоступен" v-model="isOpenWarning">
        <IconCard type="warn"> {{ warningText }}</IconCard>
        <div class="warn-modal">
          <SmButton :onClick="receptionHandle" class="warn-modal__btn"
            >Записаться на приём
            <PlusIcon />
          </SmButton>
        </div>
      </CustomModal>
    </Teleport>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import Teleport from 'vue2-teleport'

import { useRouter } from '@/router'
import { useStore } from '@/store'

import { CustomModal, IconCard } from '@/shared'
import SmButton from '@/components/button'
import PlusIcon from '@/assets/icons/plus'

export default {
  name: 'RetransferButton',
  components: {
    SmButton,
    CustomModal,
    PlusIcon,
    IconCard,
    Teleport
  },
  props: ['infoCard'],
  setup({ infoCard }) {
    const store = useStore()
    const router = useRouter()

    const isLoad = ref(false)

    const isOpenWarning = ref(false)
    const warningText = ref('')
    const receptionHandle = ref(null)

    async function retransfer() {
      const { specialityId, clinicId, doctorId } = infoCard

      isLoad.value = true
      await store.dispatch('timeslots/getTimeslots', {
        specialityIds: [specialityId],
        size: 500
      })
      isLoad.value = false

      const clinics = store.getters['timeslots/timeslotsData']

      if (!clinics.content.length) {
        receptionHandle.value = () => {
          router.push({
            path: `/appointment`
          })
        }

        warningText.value =
          'К сожалению, выбранный врач больше не ведёт приём по выбранной специальности. Пожалуйста, выберите другого врача'

        isOpenWarning.value = true
        return
      }

      const isAvailableDoctor = clinics.doctors.find((el) => el.id === doctorId)

      if (!isAvailableDoctor) {
        receptionHandle.value = () => {
          router.push({
            path: `/appointment/${specialityId}`
          })
        }

        warningText.value =
          'К сожалению выбранный врач больше не ведёт приём. Пожалуйста, выберите другого врача'

        isOpenWarning.value = true
        return
      }

      const isAvailableClinic = isAvailableDoctor.clinics.find(
        (el) => el.id === clinicId
      )

      if (!isAvailableClinic) {
        const clinicId = isAvailableDoctor.clinics[0].id

        receptionHandle.value = () => {
          router.push({
            path: `/appointment/${specialityId}`,
            query: { clinicId, doctorId }
          })
        }

        warningText.value =
          'К сожалению, выбранный врач больше не ведёт приём по выбранной специальности. Пожалуйста, выберите другого врача'
        isOpenWarning.value = true
        return
      }

      router.push({
        path: `/appointment/${specialityId}`,
        query: { clinicId, doctorId }
      })
    }

    return {
      retransfer,
      isLoad,
      isOpenWarning,
      receptionHandle,
      warningText
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
